import { Notify } from 'vant'
import { invoiceRequest, businessRequest } from '@services'
export default {
  namespaced: true,
  state: {
    companyNameList: [],
    selectGoods: [],
    goodsLoading: false,
    loading: false,
    invoiceGoodList: [
      { goodsName: '名称', priceTax: '11.00', quantity: '1', amountWithTax: '11.00', taxRate: '2%' }
    ],
    invoiceResult: {},
    allElectricInfo: {}
  },
  actions: {
    // 查询全电开票人
    async getAllElectricInfo ({ commit }) {
      const res = await invoiceRequest.apply.getAllElectricInfo({})
      if (res.success) {
        await commit('setAllElectricInfo', res.result)
      } else {
        Notify({ type: 'danger', message: res.message })
      }
    },
    // 查询税控开票讯息
    async getInvoiceResult ({ commit }) {
      const res = await invoiceRequest.apply.getInvoiceResult({})
      if (res.success) {
        await commit('setInvoiceResult', res.result)
        return res.result
      } else {
        Notify({ type: 'danger', message: res.message })
      }
    },
    // 开票，税控
    async invoicing (_, invoiceInfo) {
      const res = await invoiceRequest.apply.taxControlInvoicing(invoiceInfo)
      if (res.success) {
        Notify({ type: 'success', message: '提交成功' })
        return true
      } else {
        Notify({ type: 'danger', message: res.message })
      }
    },
    async allElectricInvoicing (_, invoiceInfo) {
      const res = await invoiceRequest.apply.allElectricInvoicing(invoiceInfo)
      if (res.success) {
        Notify({ type: 'success', message: '提交成功' })
        return true
      } else {
        Notify({ type: 'danger', message: res.message })
      }
    },
    // 开票，全电
    async getCompanyList ({ commit }, name) {
      const data = await businessRequest.qrcode.getSmartTitle({ companyName: name })
      if (data.success) {
        await commit('setCompanyNameList', data.result)
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    async getSelectGoods ({ commit }, secretKey) {
      await commit('setGoodsLoading', true)
      const data = await invoiceRequest.auditInvoicing.getSelectGoods({ secretKey })
      if (data.success) {
        await commit('setSelectGoods', data.result)
      } else {
        Notify({ type: 'danger', message: data.message })
      }
      await commit('setGoodsLoading', false)
    },
    async saveInvoiceInfo ({ commit }, invoiceInfo) {
      await commit('setLoading', true)
      const data = await invoiceRequest.auditInvoicing.saveAuditInvoiceing(invoiceInfo)
      if (data.success) {
        await commit('setLoading', false)
        return true
      } else {
        Notify({ type: 'danger', message: data.message })
      }
      await commit('setLoading', false)
    }
  },
  mutations: {
    setAllElectricInfo (state, allElectricInfo) {
      state.allElectricInfo = allElectricInfo
    },
    setInvoiceResult (state, invoiceResult) {
      state.invoiceResult = invoiceResult
    },
    setCompanyNameList (state, companyNameList) {
      state.companyNameList = companyNameList
    },
    setSelectGoods (state, selectGoods) {
      state.selectGoods = selectGoods
    },
    setInvoiceGoodList (state, invoiceGoodList) {
      state.invoiceGoodList = invoiceGoodList
    },
    setGoodsLoading (state, goodsLoading) {
      state.goodsLoading = goodsLoading
    },
    setLoading (state, loading) {
      state.loading = loading
    }
  }
}
